import React from 'react';
import {Text} from 'react-native';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';

import LoadingIndicator from '../LoadingIndicator';

export default () => (
  <>
    <Heading level={1}>Small Loading Indicator</Heading>
    <Spacer size={16} />
    <Text>
      Displays a small <Code>{'LoadingIndicator'}</Code> with the user's
      competency color.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center" expand={false}>
        <LoadingIndicator size="small" />
        <Spacer size={20} />
        <Code>{'size="small"'}</Code>
      </FlexView>
    </FlexView>
  </>
);
